import SearchBarToHomePage from "../../../../components/SearchBarToHomePage";
import {
  ContentWrapper,
  MainParagraph,
  MainTitle,
  VideoWrapper,
  Wrapper,
} from "./styles";
import React from "react";
import mainImg from "../../../../assets/pages/NewHome/veronessa-alan.png";

function SearchSection() {
  return (
    <Wrapper>
      <ContentWrapper>
        <MainTitle>Alugue rápido, anuncie de forma simples!</MainTitle>
        <MainParagraph>
          Descubra a maneira mais eficiente de alugar e anunciar imóveis.
        </MainParagraph>
      </ContentWrapper>
      <SearchBarToHomePage />
      <VideoWrapper>
        <img src={mainImg} alt="Dois colaboradores da 7cantos" loading="eager" width="1200" height="800" />
      </VideoWrapper>
    </Wrapper>
  );
}

export default SearchSection;
